var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var Tool = function Tool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Tool_a",
    d: "M938.148 291.002c-.9 0-1.758-.392-2.434-1.132l-5.235-5.624c-.627-.698-1.538-.971-2.639-.8-2.772.531-5.478-.28-7.429-2.231a8.226 8.226 0 0 1-2.054-8.217l.34-1.125 4.456 4.36a2.603 2.603 0 0 0 1.906.833c.722 0 1.4-.296 1.906-.833l.029-.028a2.603 2.603 0 0 0 .832-1.906c0-.722-.296-1.399-.832-1.906l-.02-.02-4.34-4.436 1.124-.34a8.226 8.226 0 0 1 8.217 2.054c1.985 1.985 2.837 4.905 2.224 7.62l-.007.027c-.244.915-.011 1.659.732 2.34l5.71 5.318c.95.871 1.325 2.044 1.029 3.218-.329 1.304-1.425 2.4-2.729 2.729a3.215 3.215 0 0 1-.786.099m-9.694-9.03c1.231 0 2.304.451 3.077 1.311l5.23 5.62c.663.724 1.358.735 1.824.617.797-.2 1.494-.898 1.695-1.695.118-.467.108-1.162-.612-1.819l-.004-.004-5.708-5.317c-1.121-1.028-1.518-2.322-1.145-3.74.5-2.24-.205-4.647-1.844-6.286a6.804 6.804 0 0 0-5.583-1.95l2.6 2.658a4.014 4.014 0 0 1 1.267 2.932 4.01 4.01 0 0 1-1.264 2.928 4.013 4.013 0 0 1-2.928 1.264 4.014 4.014 0 0 1-2.932-1.268l-2.657-2.6a6.798 6.798 0 0 0 1.95 5.584c1.612 1.613 3.858 2.283 6.162 1.837l.025-.004c.289-.046.572-.069.847-.069"
  }), React.createElement("path", {
    id: "Tool_b",
    d: "M938.176 287.417c-.342.342-.913.342-1.199 0-.343-.343-.343-.914 0-1.2.286-.343.857-.343 1.2 0 .342.286.342.857 0 1.2"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Tool_a",
    transform: "translate(-918 -267)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Tool_b",
    transform: "translate(-918 -267)"
  }));
};

export default Tool;